import { TrackerDataType } from '../constants/constants';

const isNonEmptyStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.length > 0 && value.every((item) => typeof item === 'string' && item.length > 0);

export const normalizeSetNotificationsToRead = (value: unknown): boolean => {
  if (value === true) return true;
  if (value === false) return false;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return false;
};

export const normalizeNotificationId = (value: unknown): string | null =>
  typeof value === 'string' && value.length > 0 ? value : null;

export const normalizeSendNotificationInput = (value: unknown): {
  destUserIds: string[];
  emailService: string;
  postId: string;
  postTitle: string;
  type: TrackerDataType;
} | null => {
  if (!value || typeof value !== 'object') return null;
  const candidate = value as {
    destUserIds?: unknown;
    emailService?: unknown;
    postId?: unknown;
    postTitle?: unknown;
    type?: unknown;
  };

  const destUserIds = isNonEmptyStringArray(candidate.destUserIds) ? candidate.destUserIds : null;
  const emailService = typeof candidate.emailService === 'string' && candidate.emailService.length > 0 ? candidate.emailService : null;
  const postId = typeof candidate.postId === 'string' && candidate.postId.length > 0 ? candidate.postId : null;
  const postTitle = typeof candidate.postTitle === 'string' && candidate.postTitle.length > 0 ? candidate.postTitle : null;
  const type =
    candidate.type === TrackerDataType.SERVICE ||
    candidate.type === TrackerDataType.MEDIA_INTERACTION ||
    candidate.type === TrackerDataType.ENGAGEMENT
      ? candidate.type
      : null;

  if (!destUserIds || !emailService || !postId || !postTitle || !type) return null;

  return { destUserIds, emailService, postId, postTitle, type };
};
